export default {
      id: "arrows-usage",
      viewBox: "0 0 18 14",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#arrows-usage",
      toString: function () {
        return this.url;
      }
    }